import { useEffect, useState } from 'react';
import axios from 'axios';
import * as Routes from '@/modules/routes';
import useGradesTableStore from '../store/useGradesTableStore';

export type TeacherCommentType = {
  id: number;
  question_id: number;
  teacher_comment: string | null;
  teacher_stamp: string | null;
  comment_updated_at: string;
  display_position: string;
};

type AssignmentCommentsType = {
  comments: TeacherCommentType[];
  newCommentCount: number;
};

const useQuestionAnswers = ({ assignmentId }) => {
  const isLoadingAssignments = useGradesTableStore(state => state.isLoadingAssignments);
  const classroomId = useGradesTableStore(state => state.classroom.id);
  const lastViewed = useGradesTableStore(state => state.lastViewed);

  const [assignmentComments, setAssignmentComments] = useState<AssignmentCommentsType>({
    comments: [],
    newCommentCount: 0,
  });

  useEffect(() => {
    if (isLoadingAssignments) return;

    const searchParams = {
      assignment_ids: [assignmentId],
      classroom_id: classroomId,
      extra_attributes: ['display_position'],
      only: ['id', 'question_id', 'teacher_comment', 'teacher_stamp', 'comment_updated_at'],
    };

    axios.get<{ data: TeacherCommentType[] }>(Routes.plato_api_for_assignments_question_answers_path(searchParams))
      .then((res) => {
        const commentsData = res.data.data || [];

        setAssignmentComments({
          comments: commentsData.filter(comment => comment.teacher_comment || comment.teacher_stamp),
          newCommentCount: commentsData
            .filter(comment => (comment.teacher_comment || comment.teacher_stamp)
              && (lastViewed === null || comment.comment_updated_at > lastViewed)).length,
        });
      });
  }, [isLoadingAssignments]);

  return assignmentComments;
};

export default useQuestionAnswers;
